import React, { useEffect } from "react";
import { useHistory, Route, Redirect } from "react-router-dom";
import { getToken } from "../utils/Auth";
import { LoginCheckService } from "../services/LoginService";
import { useSelector, useDispatch } from "react-redux";
import { setIsArticulation, setIsExamReg, setIsReReg, setPMCReRegSoftLaunch, setIsWithheld, setReRegistrations, setReRegistrationsLoading, setUser, setWidget, unsetWidget, setReRegistrationsClosed, setReRegistrationsOpen } from "../store/actions/index";
import {InActiveStudentAcess, ReRegAccess} from "../utils/CustomModels"
import { ArticulationRegistrationList, GetReRegistrationList } from "../services/ReRegistrationService";
import { GetMyOpenCloseExam } from "../services/ExamService";
import moment from "moment";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const dispatch = useDispatch();
  const location = useHistory();
  const user = useSelector((state) => state.user);
  const registrationsReload = useSelector((state) => state.registrations.reload);
  const isWithHeldStatus = localStorage.getItem("isResultWitheld");
  useEffect(() => {
    LoginCheckService()
    .then((res) => {
      dispatch(unsetWidget());
      dispatch(setWidget({ status: 1 }));
      dispatch(setUser(res?.data));
      if(res?.data?.status == "Results Witheld"){
        localStorage.setItem('resultWithHeld',JSON.stringify(true));
      } else {
        localStorage.setItem('resultWithHeld',JSON.stringify(false));
      }
      let flag=false;
      for (let i=0;i<InActiveStudentAcess.length;i++){
        if(window.location.href.includes(InActiveStudentAcess[i])){
          flag=true;
        }
      }
      if((res?.data?.status =='On Hold') && !flag) {
        location.push("/status");
      }
      if(res?.data?.status !== 'On Hold' && (res?.data?.status != "Results Witheld" || (res?.data?.status == "Results Witheld" && res?.data?.remind_me_status ==true))){
        // getting reregistration's list 
        dispatch(setReRegistrationsLoading());
        ArticulationRegistrationList().then(res1=>{
          const artiStatus = res1?.data?.open.filter(item=>(item?.nonRegData?.status !== "Declined" && (item?.remind !== 0)));
          if(artiStatus?.length){
            localStorage.setItem('reRegStatus',JSON.stringify(true));
            dispatch(setIsReReg(true));
            dispatch(setReRegistrations(artiStatus))
            dispatch(setIsArticulation(true))
            location.push("/reregStatus");
          } else {
            GetReRegistrationList()
            .then(res => {
              // find if open entries per is -1%
              const hasFilesRequiredPer = res?.data?.open.filter(item=>(item?.per == "-1%"));
              if(res?.data?.open?.length > 0 && hasFilesRequiredPer?.length > 0){
                dispatch({ type: "SET_FILES_REQUIRED", payload: 1 });
              }else{
                dispatch({ type: "SET_FILES_REQUIRED", payload: 0 });
              }                            
              let regData = res?.data?.open.filter(item=>(
                item?.per !== -1 &&
                item?.status !== "Preliminary" &&  
                item?.status !== "In-Active" && 
                item?.status !== "Completed" && 
                item?.status !== "Complete" && 
                item?.status !== "RCO" && 
                item?.status !== "Review" && 
                item?.status !== "Admin Processing" && // Admin Processing
                item?.status !== "Cancelled" && 
                item?.status !== "Accounts Verification" && //Accounts Verification
                item?.status !== "Sales" && 
                item?.status !== "Re-Reg Closed Pending" &&
                item?.status !== "Re-Reg Called" &&
                item?.status !== "Re-Reg Application Form" &&
                item?.status !== "Re-Reg Closed Won" &&
                item?.status !== "Re-Reg Quote" &&
                item?.status !== "Re-Reg Closed Lost" &&
                item?.status !== "Re-Reg Closed Cancelled" &&
                item?.status !== "Re-Registration Submitted" &&
                item?.reRegistrationStatus !== "Re-Registration Submitted" &&
                item?.reRegistrationStatus != "Re-Registration Rejected" && 
                item?.reRegistrationStatus !== "Declined" && 
                item?.status !== "Pending Payment" && 
                item?.status !== "Pending Account Information" &&
                item?.status!=="Submitted" && 
                item?.status!=="Documents Required" &&
                (item?.remind !==0 || item?.late_reg == 1)
              )).filter(item => item.show == 1);
              const status = regData.length > 0 ? true : false;
              dispatch(setReRegistrationsOpen(res?.data?.open ?? []));
              dispatch(setReRegistrationsClosed(res?.data?.close ?? []));
              dispatch(setReRegistrations(regData))
              let PmcReRegSoftLaunch = res?.data?.open.filter(item=>(
                item?.reRegistrationStatus !== "Re-Registration Submitted" 
                && item?.reRegistrationStatus != "Re-Registration"
                && item?.reRegistrationStatus != "Re-Registration-Accounts"
                && item?.reRegistrationStatus != "Re-Registration-Sales"
                && item?.reRegistrationStatus != "Re-Registration-Sales-Rejected"
                && item?.reRegistrationStatus != "Re-Registration-Sales Invoiced"
                && item?.reRegistrationStatus != "Re-Registration-Sales Admin"
                && item?.reRegistrationStatus != "Re-Registration-Study Kit Pending"
                && item?.reRegistrationStatus != "Review"
                && item?.status !== "Pending Account Information" 
                && item?.status !== "Pending Payment"
                && item?.status !== "Complete" 
                && item?.reRegistrationStatus != "Re-Registration-RCO"
                && item?.reRegistrationStatus != "Final-Status"
                && item?.reRegistrationStatus != "Re-Registration-Final"
                && item?.reRegistrationStatus != "In-Active"
                && item?.reRegistrationStatus != "Re-Registration Rejected" 
                && (item?.status ==='Exam/Supplementary Marks Pending') // How we know this is a PMC Re-Reg, this status is unique to it
                && item?.show == 1 
                && (Number(item?.remind) != 0)
                && item?.reRegistrationStatus !== "Declined"))
              if(status){
                dispatch(setIsReReg(status));                    
                localStorage.setItem('reRegStatus',JSON.stringify(status));
                let reRegFlag = false;        
                for (let i = 0; i < ReRegAccess.length; i++) {
                  if (location.location.pathname.includes(ReRegAccess[i])) {
                    reRegFlag = true;
                  }
                }
                if(PmcReRegSoftLaunch.length > 0){
                  dispatch(setPMCReRegSoftLaunch(PmcReRegSoftLaunch));
                  localStorage.setItem('PMCReRegStatus',JSON.stringify(true));
                  location.push("/ReRegUpcomming");

                }else{
                  dispatch(setPMCReRegSoftLaunch(null));
                  localStorage.setItem('PMCReRegStatus',JSON.stringify(false));
                }
                if ((res?.data?.status !== 'On Hold' ) && status && !reRegFlag) {
                  location.push("/reregStatus");
                }
                
              }else if(PmcReRegSoftLaunch.length > 0){
                dispatch(setPMCReRegSoftLaunch(PmcReRegSoftLaunch));
                localStorage.setItem('PMCReRegStatus',JSON.stringify(true));
                location.push("/ReRegUpcomming");
              }else{
                dispatch(setPMCReRegSoftLaunch(false));
                localStorage.setItem('PMCReRegStatus',JSON.stringify(false))
                GetMyOpenCloseExam().then((response)=>{
                  const examStatus = response?.data?.open.filter(item => item.registrationStudentStatus === "Not Registered" && (item.remind !==0)).length > 0 ? true : false;
                  if(examStatus){
                    dispatch(setIsReReg(false));
                    dispatch(setIsExamReg(examStatus))
                    localStorage.setItem('reRegStatus',JSON.stringify(false));
                    localStorage.setItem('examRegStatus',JSON.stringify(examStatus));
                    location.push("/examregistration")
                  }else{
                    dispatch(setIsReReg(false));
                    dispatch(setIsExamReg(false))                        
                  }                  
                }).catch((error)=>{console.log(error)})
              }
            })
            .catch(error => {
              console.error(error);
            }).finally(()=>{
              dispatch(setIsArticulation(false))
            });  
          }
        }).catch(error=>{
          console.error(error);
        })
      }
      if(res?.data?.status == "Results Witheld" && res?.data?.remind_me_status == false){          
        localStorage.setItem("isResultWitheld", true)
        dispatch(setIsWithheld(true)) 
        isWithHeldStatus && location.push("/ResultWithheld");   
      } else {
        dispatch(setIsWithheld(false))
        localStorage.setItem("isResultWitheld", false)
        // location.push("/home")  
      }
    })
    .catch((err) => {
      let response = err.response;
      if (response.status === 401) {
        location.push("/");
      }
    });
    
    return (()=>{
      dispatch(setReRegistrations([]))
    })
  }, [isWithHeldStatus, registrationsReload]);
  
  return (
    <>
    <main>
    <Route
    {...rest}
    render={(props) =>
      getToken() ? (
        <Component {...props} />
      ) : (
        <Redirect
        to={{ pathname: "/", state: { from: props.location } }}
        />
      )
    }
    />
    </main>
    </>
  );
};

export default PrivateRoute;
